// @ts-nocheck

export const SearchMaxLength = 100;
